import { Loader2 } from 'lucide-react';

import { useDemoCopyResetState } from '@/entities/sandbox-demo';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/shadcn/card';

interface ResetDemoPatientOverlayProps {
  patientUserId: string;
}

export function ResetDemoPatientOverlay({ patientUserId }: ResetDemoPatientOverlayProps) {
  const resetState = useDemoCopyResetState(patientUserId);
  if (resetState.type !== 'resetting') {
    return null;
  }

  return (
    <div className="absolute inset-0 z-[60]" aria-busy="true">
      <div className="pointer-events-auto absolute inset-0 bg-background/70 backdrop-blur-sm" />
      <div className="pointer-events-auto absolute inset-0 flex items-center justify-center p-4">
        <Card className="w-full max-w-sm shadow-lg" role="status">
          <CardHeader className="items-center text-center">
            <Loader2 className="size-6 animate-spin text-muted-foreground" aria-hidden="true" />
            <CardTitle>Resetting {resetState.displayName} to base</CardTitle>
          </CardHeader>
          <CardContent className="text-center text-sm text-muted-foreground">
            This usually takes under a minute
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
